import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = async (eventType, data = {}) => {
  try {
    await axios.post(`${BACKEND_URL}/api/analytics/track`, {
      type: eventType,
      ...data,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience
    console.error('Analytics tracking error:', error);
  }
};

export const trackPageView = (pageName) => {
  trackEvent('page_view', { page: pageName });
};

export const trackPaymentClick = () => {
  trackEvent('payment_click', { description: 'Venmo button clicked' });
};

export const trackQRView = () => {
  trackEvent('qr_view', { description: 'QR code section viewed' });
};
